import _isPlainObject from "is-plain-object";
var exports = {};
var isPlainObject = _isPlainObject;

exports = function isExtendable(val) {
  return isPlainObject(val) || typeof val === "function" || Array.isArray(val);
};

export default exports;